export default "__VITE_ASSET__$ACpvEsE__"